module.exports = require("./ff-Adlm-NG.d.ts");